import {
  APPLY_CONDITION_TO_SIDES,
  START,
  SUCCESS,
  FAIL
} from "../constants/action-types";

export default (sides = {}, action) => {
  const {type, payload, error} = action;
  switch (type) {
    case APPLY_CONDITION_TO_SIDES + START:
      return {...sides, loading: true, loaded: false};
    case APPLY_CONDITION_TO_SIDES + SUCCESS:
      return {...sides, assets: payload.assets, loading: false, loaded: true};
    case APPLY_CONDITION_TO_SIDES + FAIL:
      return {...sides, error, loading: false, loaded: true};
  }
  return sides;
};
